import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Flame, ArrowRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export const TrendingDeckBanner = () => {
  const { company } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!company) return;
    api.get(`/companies/${company.id}/deck-trending`).then(({ data }) => setData(data)).catch(() => {});
  }, [company]);

  if (!data?.trending) return null;
  return (
    <Card className="mb-6 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-orange-200 bg-orange-50/70 p-4" data-testid="trending-deck-banner">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-orange-100 text-orange-600"><Flame className="h-5 w-5" /></div>
        <div>
          <div className="text-sm font-semibold text-foreground">"{data.link_name}" is trending</div>
          <div className="text-xs text-muted-foreground" data-testid="trending-deck-views">{data.views_last_hour} views in the last hour - interest is hot, follow up now.</div>
        </div>
      </div>
      <Button variant="outline" size="sm" className="gap-1.5 border-orange-200 text-orange-700 hover:bg-orange-100" onClick={() => navigate("/app/deck-links")} data-testid="trending-deck-view-btn">
        See who's viewing <ArrowRight className="h-3.5 w-3.5" />
      </Button>
    </Card>
  );
};
